import { useCallback, useEffect, useState } from 'react';

import { FetchUserProps, fetchUsers } from 'lib/models/users';
import useIsAppUsers from './useIsAppUsers';

function useUsers(props: FetchUserProps) {
	const isAppUsers = useIsAppUsers();

	const [loading, setLoading] = useState<boolean>(true);
	const [users, setUsers] = useState<PaginateSource<User>>({ total: 0, elements: [] });

	const refetch = useCallback(async () => {
		const response = await fetchUsers(isAppUsers, props);
		setUsers(response);
		setLoading(false);
	}, [props, isAppUsers]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, users, refetch, setLoading };
}

export default useUsers;
